export { default } from './GuageOutline'
